import clsx from 'clsx';
import React from 'react';
import styles from './MagazineHeroArea.module.scss';

const MagazineHeroArea = ({ children }: { children: React.ReactNode }) => (
  <section className={clsx(styles.wrapperLarge)} data-with-section-spaces>
    {children}
  </section>
);

export default MagazineHeroArea;
